import EnhancedStepper from '@components/stepper/EnhancedStepper';
import FormattingService from '@services/FormattingService';
import { MAIN_THEME } from '@styles';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  stepperContainer: {
    margin: '20px 0',
    display: 'grid',
    gridTemplateColumns: '2fr 1fr',
    gap: '1em',
    alignItems: 'start',
  },
  stepper: {
    backgroundColor: 'transparent',
    width: '95%',
    marginBottom: '20px',
    '& .MuiStepLabel-root .Mui-active, .MuiStepLabel-root .Mui-completed': {
      color: MAIN_THEME.color.black,
    },

    '@media only screen and (min-width: 600px)': {
      maxWidth: '1300px',
    },
  },
}));

const Stepper: React.FC<{
  activeStep: string;
}> = ({ activeStep }) => {
  const { classes } = useStyles();
  const steps: string[] = ['BOUND', 'INFORCE', 'CANCELLED'];
  return (
    <div className={classes.stepperContainer}>
      <EnhancedStepper
        activeStep={FormattingService.formatEnumToDisplay(activeStep)}
        steps={steps.map((step) => FormattingService.formatEnumToDisplay(step))}
        className={classes.stepper}
      />
    </div>
  );
};

export default Stepper;
